import { useEffect } from "react";
import { Button, Container } from "react-bootstrap";
import SntCheckBox from "@cleanup/components/SntCheckBox/SntCheckBox";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";

interface GeneralFooterFilterProps {
  onClearFilter: () => void;
  onAppliedFilter: () => void;
  isNotFilter?: boolean;
  onCheckNotFilter?: (checked: boolean) => void;
  disableCheckBox?: boolean;
  isShowExclude?: boolean;
}

const GeneralFooterFilter: React.FC<GeneralFooterFilterProps> = ({
  onClearFilter,
  onAppliedFilter,
  isNotFilter = false,
  onCheckNotFilter,
  disableCheckBox = true,
  isShowExclude = true,
}) => {

  useEffect(() => {
    if (disableCheckBox) {
      onCheckNotFilter?.(false);
    }
    // eslint-disable-next-line
  }, [disableCheckBox]);
  return (
    <>
      <div className="mb-3 border-top border-sensolus-grey"></div>
      <Container>
        <div className="d-flex flex-row flex-wrap align-items-center gap-3">
          <div className="mb-3 d-flex gap-2">
            <Button variant="sensolus" onClick={onAppliedFilter}>
              {translate(LanguageKey.apply_key)}
            </Button>
            <Button variant="outline-sensolus" onClick={onClearFilter}>
              {translate(LanguageKey.clear_key)}
            </Button>
          </div>

          {isShowExclude && (
            <div className="mb-3 align-self-center">
              <SntCheckBox
                checked={disableCheckBox ? false : isNotFilter}
                onChange={onCheckNotFilter}
                disabled={disableCheckBox}
                label={
                  <label className="fw-bold">
                    {translate(LanguageKey.exclude_key)}
                  </label>
                }
              />
            </div>
          )}
        </div>
      </Container>
    </>
  );
};

export default GeneralFooterFilter;
